import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./config";

const Ctx = createContext(null);

const DEFAULTS = { shop_enabled: true, blog_enabled: true };

export function FeaturesProvider({ children }) {
  const [features, setFeatures] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/settings/features");
      setFeatures({ ...DEFAULTS, ...(r.data || {}) });
    } catch {
      setFeatures(DEFAULTS);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <Ctx.Provider value={{ features, loaded, refresh }}>
      {children}
    </Ctx.Provider>
  );
}

export const useFeatures = () => useContext(Ctx) || { features: DEFAULTS, loaded: false, refresh: () => {} };
